import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import DropdownSingleSelectWithoutSearch from "shared/components/inputs/dropdown/DropdownSingleSelectWithoutSearch";
import EmptyState from "shared/components/data-display/tables/EmptyState";
import GlobalConfig from "app/config/global";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import { StyledEmptyState } from "features/projects/retainers-dashboard/RetainersDashboardNav.styles";
import VStack from "shared/components/layout/stack/VStack";
import { getDropdownOptionsNoDefaultVal } from "shared/helper-functions/dropdown/dropdownHelpers";
import useSelectorProjects from "features/projects/project-dashboard/useProjectsDashboard";

const ProjectsDashboardNav = ({ refreshButtonElement = null }) => {
    const { projectId } = useParams();
    const [value, setValue] = useState(projectId);
    const navigate = useNavigate();
    const projectsDashboardPath = GlobalConfig.routes.projectsDashboardLanding;

    const { selectorProjects } = useSelectorProjects();

    const handleOnChange = (id) => {
        setValue(id);
        navigate(`${projectsDashboardPath}/${id}`);
    };

    const projectIdStored = JSON.parse(localStorage.getItem("storedProjectId"));

    useEffect(() => {

        if (!selectorProjects?.isLoading
            && selectorProjects?.data?.length > 0
            && (!value || !projectIdStored)) {
                
            navigate(`${projectsDashboardPath}/${selectorProjects?.data[0].Id}`);
        }

    }, [selectorProjects, navigate, projectIdStored, projectsDashboardPath, value]);

    useEffect(() => {
        setValue(projectIdStored);
    }, [projectIdStored]);

    const projectsOptions = getDropdownOptionsNoDefaultVal(
        selectorProjects?.data
    );

    if (selectorProjects.isError) {
        return <>Error</>;
    }

    const selectorProjectsLength = selectorProjects?.data?.length;

    return (
        <VStack>
            {selectorProjectsLength > 0 && !selectorProjects.isLoading && (
                <HStack align="center">
                    <DropdownSingleSelectWithoutSearch
                        className="dashboard-selector"
                        isSmallSize={true}
                        options={projectsOptions}
                        value={value}
                        onChange={handleOnChange}
                        disabled={
                            selectorProjects.isLoading ||
                            projectsOptions?.length === 0
                        }
                    />
                    {refreshButtonElement}
                </HStack>
            )}

            {selectorProjectsLength > 0
                ? !value && (
                    <EmptyState message="There are no content to show. Start by selecting project." />
                )
                : !selectorProjects.isLoading && (
                    <StyledEmptyState
                        className="dashboard-selector"
                        message="You don't have any assigned project"
                    />
                )}
        </VStack>
    );
};

ProjectsDashboardNav.propTypes = {
    refreshButtonElement: PropTypes.node
};

export default ProjectsDashboardNav;
